export default {
  state: {
    getReport: "Solicita um relatório com o intervalo de datas:",
    getIntroToGetReport: ""
  },
  mutations: {
    SET_INTRO(state, value) {
      state.getIntroToGetReport = value;
    }
  },
  actions: {
    setNameAndNif(context, payload) {
      let message = "A Empresa com o NIF " + payload.nif + " " + payload.name + " ";
      context.commit("SET_INTRO", message);
    }
  },

  getters: {
    getMessageToRequestReport(state) {
      return state.getReport;
    },
    getNameToRequestReport(state) {
      return state.getIntroToGetReport;
    }
  }
};
